import {
    SimplePageContentWrapper,
    SimplePageLayout,
} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {RecordsTable} from '../tables/RecordsTable';
import {useSetupIntentsSelection} from '../hooks/useSetupIntentsSelection';

/**
 * FNP-918: the setup-intents index page.
 *
 * Selection was `useState<SetupIntent[]>` here and threaded into the table as
 * two props; it is now the Redux `setup-intents.selection` slice (§3, FNP-951).
 * The page still owns the hook instance and passes it down, because the DELETE
 * button lives in the page header — a sibling of the table, not a child — so
 * something above both has to hold the reference.
 *
 * ⚠️ Selection survives unmount now that it is in the store, so the batch
 * delete must clear it explicitly: handleClearSelection is passed as
 * onDeleteComplete. Without that, ids of deleted rows stay selected and the
 * next delete targets setup intents that no longer exist.
 */
export const IndexPage = () => {

    const selection = useSetupIntentsSelection();

    return (
        <SimplePageLayout
            pageHeader={
                <IndexPageHeader
                    selectedIds={selection.selectedIds}
                    onDeleteComplete={selection.handleClearSelection}
                />
            }
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordsTable selection={selection}/>
            </SimplePageContentWrapper>
        </SimplePageLayout>
    );
};
